/**
 * @hidden
 */
export var packageMetadata = {
    name: '@progress/kendo-vue-intl',
    productName: 'Kendo UI for Vue',
    productCodes: ['KENDOUIVUE', 'KENDOUICOMPLETE'],
    publishDate: 1635492707,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-vue-ui/my-license/?utm_medium=product&utm_source=kendovue&utm_campaign=kendo-ui-vue-purchase-license-keys-warning'
};
